import cmsParser from 'Common/util/cmsParser';
import type { PageEntry, Node } from 'contensis-delivery-api';
import { useTheme } from 'styled-components';

import { composerVirtualTour } from 'Common/util/cmsComposer';

import type { Props } from './VirtualTour';

export type PageData = {
    entry: PageEntry;
    ancestors: Node[];
};

const datamap = (data: PageData): Props => {
    const { entry, ancestors } = data;

    const {
        title,
        sys,
        // Hero Banner
        heading,
        subHeading,
        // Virtual Tour Cards
        virtualTours,
        // Promo Card
        promoCardPreheading,
        promoCardHeading,
        promoCardLink,
        promoCardImage
    } = entry;

    const { colors } = useTheme();

    return {
        breadcrumbs: cmsParser.breadcrumbs([...ancestors, { entry: { title: title }, id: sys.id }]),
        heroBanner: {
            heading: heading,
            subHeading: subHeading
        },
        content: composerVirtualTour(virtualTours),
        promoCard:
            promoCardImage && promoCardPreheading && promoCardHeading && promoCardLink
                ? {
                      image: cmsParser.image(promoCardImage),
                      heading: promoCardPreheading,
                      description: promoCardHeading,
                      button: {
                          ...cmsParser.linkButton(promoCardLink),
                          variant: 'accentOneTertiary'
                      },
                      backgroundColour: colors.secondary.tints[12].hex,
                      colour: colors.accents[1].hex
                  }
                : undefined
    };
};

export default datamap;
